import { ALL_ONBOARDING_PAID_SCOPES, ONBOARDING_ENTERPRISE_SCOPES, ONBOARDING_PRO_SCOPES, ONBOARDING_STARTER_SCOPES, PRO_PLUS_ONBOARDING_SCOPES } from 'onboarding-scopes/scopeConstants';
import { ownsAny, ownsNone } from './ownershipUtils';
export const getIsFreePortal = scopes => {
  return ownsNone(scopes, ALL_ONBOARDING_PAID_SCOPES);
};
export const getOwnsPaidPortal = scopes => {
  return ownsAny(scopes, ALL_ONBOARDING_PAID_SCOPES);
};
export const getOwnsOnlyStarterPortal = scopes => {
  return ownsAny(scopes, ONBOARDING_STARTER_SCOPES) && ownsNone(scopes, PRO_PLUS_ONBOARDING_SCOPES);
};
export const getOwnsStarterPortal = scopes => {
  return ownsAny(scopes, ONBOARDING_STARTER_SCOPES);
};
export const getOwnsFreeOrStarterPortal = scopes => {
  return ownsNone(scopes, PRO_PLUS_ONBOARDING_SCOPES);
};
export const getOwnsOnlyProPortal = scopes => {
  return ownsNone(scopes, ONBOARDING_STARTER_SCOPES) && ownsAny(scopes, ONBOARDING_PRO_SCOPES) && ownsNone(scopes, ONBOARDING_ENTERPRISE_SCOPES);
};
export const getOwnsProPortal = scopes => {
  return ownsAny(scopes, ONBOARDING_PRO_SCOPES);
};
export const getOwnsProPlusPortal = scopes => {
  return ownsAny(scopes, PRO_PLUS_ONBOARDING_SCOPES);
};
export const getOwnsOnlyEnterprisePortal = scopes => {
  return ownsNone(scopes, ONBOARDING_STARTER_SCOPES) && ownsNone(scopes, ONBOARDING_PRO_SCOPES) && ownsAny(scopes, ONBOARDING_ENTERPRISE_SCOPES);
};
export const getOwnsEnterprisePortal = scopes => {
  return ownsAny(scopes, ONBOARDING_ENTERPRISE_SCOPES);
};